import axios from 'axios';

const normalizeBaseUrl = (value) => {
  if (!value) return '';
  const v = String(value).trim();
  if (!v) return '';
  return v.replace(/\/+$/, '');
};

const stripApiSuffix = (value) => {
  if (!value) return '';
  const v = String(value).trim();
  if (!v) return '';
  return v.replace(/\/api$/i, '');
};

// 统一从环境变量读取后端地址（不包含 /api），默认本地开发地址
// 兼容误配置：如果传入值已包含 /api，则自动剥离，避免出现 /api/api
const API_BASE =
  stripApiSuffix(normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL)) || 'http://localhost:8081';
const API_URL = `${API_BASE}/api`;
const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const url = typeof config.url === 'string' ? config.url : '';
    const isPublicAuthRequest =
      url.includes('/auth/login') ||
      url.includes('/auth/signup') ||
      url.includes('/auth/reset-password');

    if (!isPublicAuthRequest) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const config = error.config || error.response.config || {};
      const url = config.url || '';

      const isExpected404 = status === 404 && (
        (typeof url === 'string' && url.includes('/dealer-regions/current')) ||
        (typeof url === 'string' && url.includes('/current-region'))
      );

      if (!isExpected404) {
        console.error(`请求失败 [${status}]: ${config.method?.toUpperCase()} ${url}`);
      }

      if (status === 401) {
        try {
          const msg = error.response?.data?.message || error.response?.data || '登录已失效，请重新登录';
          sessionStorage.setItem('auth:logoutReason', typeof msg === 'string' ? msg : '登录已失效，请重新登录');
        } catch (_) {}
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    } else if (error.request) {
      console.error('未收到响应:', error.request);
    } else {
      console.error('请求配置错误:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance; 
